import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <div className="text-center mb-8">
      {/* Logo and Branding */}
      <div className="mb-6">
        <div className="w-20 h-20 bg-gradient-to-br from-primary to-primary/80 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
          <Icon name="Shield" size={40} color="white" />
        </div>
        <h1 className="text-3xl font-bold text-foreground mb-2">
          SecureVault Enterprise
        </h1>
        <p className="text-muted-foreground">
          Zero-knowledge password management for organizations
        </p>
      </div>

      {/* Status Indicator */}
      <div className="inline-flex items-center space-x-2 bg-success/10 text-success px-3 py-1 rounded-full text-sm">
        <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
        <span>All systems operational</span>
      </div>

      {/* Version Info */}
      <div className="mt-4 text-xs text-muted-foreground">
        Version 2.1.0 • Last updated: September {currentYear}
      </div>
    </div>
  );
};

export default LoginHeader;